import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { Dashboard } from 'components/Layout';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import api from 'api/api';
import { ProductsReducerType } from 'store/modules/products/products.types';
import { useFormatMessage } from 'components/IntlProvider';
import WorkbenchDetail from 'components/Workbenches/WorkbenchDetail';

const { connect, selectors, actions } = StoreProvider;

interface CreateProjectProps extends RouteComponentProps<any> {
  setProducts: (products: ProductsReducerType['list']) => void;
  products: ProductsReducerType['list'];
  organizationName: string;
  language: string;
  isBexioUser: boolean;
}

type prev = {
  [key: string]: any;
};

const CreateProject = ({
  location,
  setProducts,
  products,
  history,
  language,
  organizationName,
  isBexioUser,
}: CreateProjectProps) => {
  const t = useFormatMessage();

  useEffect(() => {
    if (isBexioUser) return history.push('/');

    api.resources
      .getPrivateProducts(organizationName)
      .then((privateProductsResp: any) => {
        setProducts(privateProductsResp.data);
      });

    // eslint-disable-next-line
  }, []);
  const onProductClick = (slug: string) =>
    history.push(`/organization/${organizationName}/products/${slug}`);
  const workbenchesReduce = products.results.reduce((prev: prev, act) => {
    const workbenchId: number = act.workbench!.id;
    if (workbenchId in prev) {
      prev[workbenchId]!.tools.push(act);
    } else {
      prev[workbenchId]! = { ...act.workbench, tools: [] };
      prev[workbenchId]!.tools.push(act);
    }
    return prev;
  }, {});

  const workbenches = Object.values(workbenchesReduce);

  return (
    <Dashboard
      title={t('project.addProject', 'New project')}
      headerSubtitle={t(
        'project.create.product',
        'Choose an Insight Tool for your new project.'
      )}
      location={location}
    >
      {workbenches &&
        workbenches.length > 0 &&
        workbenches.map((workbench: any) => (
          <WorkbenchDetail
            key={`workbenchDetail-${workbench.id}`}
            onProductClick={onProductClick}
            language={language || 'en'}
            {...workbench}
          />
        ))}
    </Dashboard>
  );
};

export default connect(
  (state) => ({
    products: selectors.products.list(state),
    organizationName:
      selectors.authSelectors.userOrganizations(state)[0].codename,
    language: selectors.intlSelectors.language(state),
    isBexioUser: selectors.authSelectors.isBexioUser(state),
  }),
  {
    setProducts: actions.products.setProducts,
  }
)(CreateProject);
